import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AutomationSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AutomationSVG;
